export const SIDEBAROPEN = '@sidebaropen';
export const SIDEBARSHOW = '@sidebarshow';
